import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { PreloaderHandler, DOTS_FULL, MULTICOLOR_FULL, BLUE_FULL } from '../../preloader/preloader-handler';
import { OidcSecurityService } from '../../../auth/services/oidc.security.service';
import { NoteWidgetService } from './note-widget.service';
import { NoteSearchModel } from '../../models/note-related/NoteSearchModel';
import { NotificationHandlerService } from '../../notifications/notification-handler.service';

@Component({
    selector: 'note-widget',
    templateUrl: 'note-widget.component.html'
})

export class NoteWidgetComponent {

    @Input() data: NoteSearchModel;
    private originalNoteContent: string;
    @Output() updated = new EventEmitter();
    @Output() deleted = new EventEmitter();
    @Output() export = new EventEmitter();
    public preloaderHandler: PreloaderHandler;
    private isEditable = false;
    private deleteConfirm = false;

    constructor(private _widgetService: NoteWidgetService,
        private _notificationService: NotificationHandlerService,
        public oidcSecurityService: OidcSecurityService) {
        let timeout = 850;
        let itemLoadCount = 1;
        this.preloaderHandler = new PreloaderHandler(itemLoadCount, timeout, BLUE_FULL);
    }

    ngOnInit(): void {
        if (this.data) {
            this.updateOriginalContent();
            this.preloaderHandler.itemLoaded();
        }
    }

    private exportData(): void {
        this.export.emit(this.data);
    }

    private updateOriginalContent(): void {
        this.originalNoteContent = this.data.NoteContent;
    }

    private refreshData(): void {
        this.preloaderHandler.reset();
        this.getData();
    }

    private toggleDeleteConfirm(): void {
        this.deleteConfirm = !this.deleteConfirm;
    }

    private toggleEdit(): void {
        this.isEditable = !this.isEditable;
    }

    private cancelEdit(): void {
        this.isEditable = false;
        this.data.NoteContent = this.originalNoteContent;
    }

    private saveData(): void {
        this.toggleEdit();
        this.preloaderHandler.reset();
        this._widgetService
            .Update(this.data.NoteId, this.data.NoteContent)
            .subscribe(data => {
            },
            error => {
                this.oidcSecurityService.handleError(error),
                this._notificationService.handleError(error)
            },
            () => {
                this.refreshData(),
                this.updated.emit(true)
            });
    }

    private deleteData(): void {
        this.preloaderHandler.reset();
        this._widgetService
            .Delete(this.data.NoteId)
            .subscribe(data => {
            },
            error => {
                this.oidcSecurityService.handleError(error),
                this._notificationService.handleError(error)
            },
            () => {
                this.deleted.emit(this.data)
            });
    }

    private getData(): void {
        this._widgetService
            .Get(this.data.NoteId)
            .subscribe(data => {
                this.data = data
            },
            error => {
                this.oidcSecurityService.handleError(error),
                this._notificationService.handleError(error)
            },
            () => {
                this.preloaderHandler.itemLoaded(),
                this.updateOriginalContent()
            });
    }

    private getDateStr(): string {
        let date = new Date(this.data.DateEdited);
        let months = [' Jan ', ' Feb ', ' Mar ', ' Apr ', ' May ', ' Jun ',
            ' Jul ', ' Aug ', ' Sep ', ' Oct ', ' Nov ', ' Dec '];
        return (date.getDate() + months[date.getMonth()].toUpperCase() + date.getFullYear());
    }
}



// WEBPACK FOOTER //
// ./angularApp/app/shared/note-widget-container/note-widget/note-widget.component.ts